const AbiDutyCalculationApiUrls = {
  UPLOAD: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload-duty/upload`,
  DOWNLOAD_FILE: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload-duty/downloadFile`,
  DOWNLOAD: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload-duty/download`,
  GET_FILE_UPLOAD: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload-duty/get`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload-duty/delete`,
};

export default AbiDutyCalculationApiUrls
